<template>
  <div class="lawofflatestin">
    <sub-title text="合肥最新入驻律所" />
    <div class="latestinlist">
      <div
        class="latestinitem flex_start"
        v-for="(item, index) in 10"
        :key="index"
        @mouseover="itemact = index"
        :class="{ latestinact: itemact == index }"
      >
        <div class="left">
          <div class="cove">
            <img src="../../../assets/findlawchild/locfircover.png" alt="" />
          </div>
          <div
            class="sortp center"
            :class="{
              sortp1: index == 0,
              sortp2: index == 1,
              sortp3: index == 2,
            }"
          >
            {{ item }}
          </div>
        </div>
        <div class="infotext">
          <div class="name ellipsis">上海锦天城锦天城（合肥）律师事务所</div>
          <div class="zhuren ellipsis">主任律师：朱明</div>
          <div class="yewu ellipsis">业务领域：房产纠纷，公司上市，...</div>
        </div>
      </div>

    </div>
  </div>
</template>


<script>
import subTitle from "views/home/components/subTitle";
export default {
  components: {
    subTitle,
  },
  data: () => ({
    itemact: 0,
  }),
};
</script>

<style lang="scss" scoped>
.lawofflatestin {
  width: 100%;
  height: 100%;
  padding: 23px 12px 30px;
  .latestinlist {
    padding: 10px 0 0 5px;
    .latestinitem {
      margin-top: 20px;
      .left {
        .sortp {
          color: #0183ff;
          margin-right: 10px;
          width: 20px;
          height: 20px;
          background: #d8ecff;
          border-radius: 2px;
          font-size: 12px;
        }

        .sortp1 {
          background-color: #ff6600;
          color: #fff;
        }
        .sortp2 {
          background-color: #ff8b3e;
          color: #fff;
        }
        .sortp3 {
          background-color: #f4ab2b;
          color: #fff;
        }
        .cove {
          display: none;
          img {
            width: 74px;
            height: 62px;
            margin-right: 6px;
          }
        }
      }
      .infotext {
        width: 240px;
        .name {
          font-size: 14px;
          color: #666666;
          line-height: 14px;
        }
        .zhuren,
        .yewu {
          display: none;
          font-size: 12px;
          color: #999999;
          margin-top: 6px;
        }
        .zhuren {
          margin-top: 10px;
        }
      }
      &.latestinact {
        .left {
          .sortp {
            display: none;
          }
          .cove {
            display: block;
          }
        }
        .infotext {
          width: 194px;
          .zhuren,
          .yewu {
            display: block;
          }
        }
      }
    }
  }
}
</style>